import _, {isPlainObject, startCase} from 'lodash'
import React from 'react'

export type ValidationErrorObject = Record<string, string | string[]>
export type ValidationError = string | ValidationErrorObject
export type ValidationErrors = ValidationError | string[]

export interface ErrorMessageProps {
    message?: string
    errors?: ValidationErrors
}

export default function ErrorMessage(props: ErrorMessageProps) {
    const errors = props.errors ? (Array.isArray(props.errors) ? props.errors.filter(Boolean) : [props.errors]) : []

    if(errors.length === 0) {
        return <p>{props.message || "An unknown error occurred"}</p>
    }

    if(errors.length === 1) {
        return <>
            <p>{props.message || "An error occurred"}:</p>
            {typeof errors[0] === 'string' ? <p>{errors[0]}</p> : renderError(errors[0])}
        </>
    }

    return (
        <>
            <p>{props.message || `${errors.length} errors occurred`}:</p>
            <ul>
                {errors.map((err, i) => <li key={i}>{renderError(err)}</li>)}
            </ul>
        </>
    )
}

function renderError(err: ValidationError) {
    if(isPlainObject(err)) {
        return <ul>
            {Object.entries(err).map(([key, value]) => (
                <li key={key}>
                    {Array.isArray(value) ? <>
                        {startCase(key)}
                        <ul>
                            {value.filter(Boolean).map((s, i) => <li key={i}>{s}</li>)}
                        </ul>
                    </> : value}
                </li>
            ))}
        </ul>
    }
    return err
}

export function FlattenedErrorMessage(props: { errors: ValidationErrors }) {
    const count = _.size(props.errors)
    return (
        <>
            <p>{count === 1 ? 'An error' : `${count} errors`} occurred:</p>
            <ul>
                {_.flatten(_.values(props.errors)).map((err, i) => <li key={i}>{err}</li>)}
            </ul>
        </>
    )
}
